import axios from "axios";
import config from "@/config";
import store from "@/store";

export default {
	runJob(payload) {
		return axios.post(
			`${config.ZETTA_URL}/jobs-api/job/runjob`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		)
	},

	getJobState(jobKey) {
		return axios.get(
			`${config.ZETTA_URL}/jobs-api/job/${jobKey}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		)
	},

	assetJobSchedule(AssetID) {
		return axios.post(
			`${config.ZETTA_URL}/jobs-api/job/schedule/graphql`,
			{
				query: `{
					jobschedules(
						filter: {ScheduleKey: {EQ: "ftpingest-${AssetID}"}}
					) {ScheduleKey, StationID, CronSchedule, ScheduleJobData, ModifiedDateTime}
				}`
			},
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		);
	},

	useImportServiceGraphql() {
		return axios.post(
			`${config.PORTAL_PROXY_URL}/api/v1/import-service/accounts/${store.getters.getOrgID()}/graphql`,
			{
				query: `
					query UseImportService { 
						useImportService
					}
				`
			},
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		)
	},

	createAssetImport(request) {
		return axios.post(
			`${config.PORTAL_PROXY_URL}/api/v1/import-service/accounts/${store.getters.getOrgID()}/graphql`,
			{
				query: `
					mutation CreateAssetImport($request: ImportServiceRequestGraph!) {
						createAssetImport(request: $request) {
							url
							jobKey
						}
					}
				`,
				variables: {
					request: request
				}
			},
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		)
	},

	getScheduleHistory(scheduleKey) {
		return axios.get(
			`${config.ZETTA_URL}/jobs-api/job/history/${scheduleKey}?limit=5`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		)
	}
}
